export default submission => Boolean(submission.is_confirmation_sent);
